import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';

export default ExpandMoreRounded;
